import { getCurrentInstance } from "vue";

// We have some things on root that we need to access sometimes, as this was
// a vue@2 pattern. This creates ability to access it from vue@3 setup where
// root is not accessible anymore through args.
export const useRoot = () => {
  const vm = getCurrentInstance();
  return vm?.$root ?? vm?.root ?? vm?.proxy?.$root;
};
